export const linkClass = 'underline text-blue-700 font-sans max-w-full text-elipsis'
